import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import { CustomTextField, SectionWrapper } from '@components/Styles/CommonStyle';
import { useNavigate } from 'react-router-dom';
import { Checkbox, Button, TableBody, TableHead, Select, MenuItem } from '@mui/material';
import Pagination from '@components/common/Shared/Pagination';
import { CustomSorting } from '@components/Styles/TableStyle';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomButton } from '@components/Styles/ButtonStyle';
import { CustomStack } from '@components/Styles/CommonStyle';
import React from 'react';
import { Typography } from '@mui/material';
import { theme } from '@components/Styles/theme';
import { formatPhoneNumber } from '@utils/formatter';

const FreeAccountListTable = ({ freeAccountList, 
  freeAccountListTotal, 
  setName, 
  onSearch, 
  onDefaultSearch,
  page, 
  pageSize, 
  setPage,
  setPageSize,
  onDeleteAccount,
  checkedAccountList,
  isCheckboxAllSelect,
  handleCheckboxChange,
  handleCheckAll,
  orderBy,
  setOrderBy,
  orderDir,
  setOrderDir,
}) => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <SectionWrapper>
        <CustomStack mb={2}>
          <Typography sx={theme.typography.h4}>검색</Typography>
        </CustomStack>
        <CustomTableContainer>
          <CustomTable>
            <TableBody>
              <CustomTableRow>
                <CustomHeaderCell>성명</CustomHeaderCell>
                <CustomBodyCell>
                  <CustomTextField
                    onChange={(e) => setName(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        onSearch();
                      }
                    }}
                  />
                </CustomBodyCell>
              </CustomTableRow>
            </TableBody>
          </CustomTable>
        </CustomTableContainer>
        <CustomStack justifyContent="center" mt={2}>
          <CustomButton type="search" onClick={onSearch}>
            검색
          </CustomButton>
        </CustomStack>
      </SectionWrapper>

      <SectionWrapper>
        <CustomStack justifyContent="spaceBetween" mb={2}>
          <Typography sx={theme.typography.h4}>프리랜서 리스트</Typography>
          <CustomStack justifyContent="spaceBetween" mb={2}>
            <CustomButton onClick={() => navigate('/account/freeAccountCreate')}>신규등록</CustomButton>
            <CustomButton color="error" onClick={() => {onDeleteAccount();}}>삭제</CustomButton>
          </CustomStack>
        </CustomStack>
        <CustomTableContainer>
          <CustomTable>
            <TableHead>
              <CustomTableRow>
                <CustomHeaderCell align="center">
                  <Checkbox              
                    checked={isCheckboxAllSelect}    
                    onChange={handleCheckAll}
                    />
                </CustomHeaderCell>
                <CustomHeaderCell align="center">NO</CustomHeaderCell>
                <CustomHeaderCell align="center">
                  성명
                  {
                    orderBy === 'person_name' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('person_name');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'person_name' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('person_name');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('person_name');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  휴대전화
                  {
                    orderBy === 'tel' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('tel');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'tel' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('tel');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('tel');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  이메일
                  {
                    orderBy === 'email' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('email');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'email' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('email');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('email');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  신분증
                  {
                    orderBy === 'id_card_url' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('id_card_url');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'id_card_url' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('id_card_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('id_card_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  통장사본
                  {
                    orderBy === 'bankbook_url' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('bankbook_url');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'bankbook_url' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('bankbook_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('bankbook_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
              </CustomTableRow>
            </TableHead>
            <TableBody>
              {freeAccountList.length > 0 ? (
                freeAccountList.map((item, index) => {
                  return (
                    <CustomTableRow>
                      <CustomBodyCell align="center">
                        <Checkbox
                          checked={checkedAccountList.includes(item.id)}
                          onChange={(e) => handleCheckboxChange(e, item.id )}
                        />
                      </CustomBodyCell>
                      <CustomBodyCell align="center">
                        {freeAccountListTotal - ((page - 1) * pageSize + index)}
                      </CustomBodyCell>
                      <CustomBodyCell align="center">
                        <Button variant="text" 
                            onClick={() => navigate('/account/freeAccountCreate?id='+item.id )}>{item.person_name}
                        </Button>
                      </CustomBodyCell>
                      <CustomBodyCell align="center">{item.tel ? formatPhoneNumber(item.tel) : '-'}</CustomBodyCell>
                      <CustomBodyCell align="center">{item.email ? item.email : '-'}</CustomBodyCell>
                      {
                        item.id_card_url !== null ?
                      <CustomBodyCell align="center">
                        <Button
                          variant="text"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(process.env.REACT_APP_API_URL + item.id_card_url, '_blank');
                          }}
                        >
                          파일보기
                        </Button>
                      </CustomBodyCell> :
                        <CustomBodyCell align="center">
                          -
                        </CustomBodyCell>
                      }
                      {
                        item.bankbook_url !== null ?
                      <CustomBodyCell align="center">
                        <Button
                          variant="text"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(process.env.REACT_APP_API_URL + item.bankbook_url, '_blank');
                          }}
                        >
                          파일보기
                          </Button>
                        </CustomBodyCell> :
                          <CustomBodyCell align="center">
                            -
                          </CustomBodyCell>
                      }
                    </CustomTableRow>
                  );
                })
              ) : (
                <CustomTableRow>
                  <CustomBodyCell colSpan={7} align="center">
                    등록된 프리랜서가 없습니다.
                  </CustomBodyCell>
                </CustomTableRow>
              )}
            </TableBody>
          </CustomTable>
        </CustomTableContainer>

        <Select
          sx={{ mt: 2, width: '100px', height: '40px' }}
          value={pageSize}
          onChange={(e) => setPageSize(e.target.value)}
        >
          {/* <MenuItem value={1}>1</MenuItem> */}
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={20}>20</MenuItem>
          <MenuItem value={30}>30</MenuItem>
        </Select>

        <Pagination count={Math.ceil(freeAccountListTotal / pageSize)} page={page} onChange={onDefaultSearch} />
      </SectionWrapper>
    </React.Fragment>
  );
};

export default FreeAccountListTable;
